import { useIsSparkle } from "@/lib/useTheme";
import { ScreenTitle } from "@/components/sparkle/kit";
import { Star5 } from "@/components/sparkle/glyphs";

/**
 * Page header that's theme-aware: the rainbow-wordmark ScreenTitle under
 * [data-theme="sparkle"], the plain heading otherwise. Same data either way —
 * a presentation swap, so every screen gets the Sparkle identity for free.
 */
export function PageHeading({
  title,
  sub,
  eyebrow = "Kovach Consulting",
}: {
  title: string;
  sub: string;
  eyebrow?: string;
}) {
  const sparkle = useIsSparkle();
  if (sparkle) {
    return (
      <ScreenTitle eyebrow={eyebrow} title={title} sub={sub} star={<Star5 size={24} color="#FFD400" />} />
    );
  }
  return (
    <header>
      <h1 className="text-3xl font-bold">{title}.</h1>
      <p className="mt-1 text-muted-foreground">{sub}</p>
    </header>
  );
}
